import PumpSettingsDashboard from './pump-settings-dashboard.container';

export default PumpSettingsDashboard;
